import type { HelpCenterHomeState } from './types';

export const defaultState: HelpCenterHomeState = {
  isLoading: true,
  preloaded: false,
  suggestedArticles: [],
  suggestedArticlesType: '',
  categories: [],
  announcements: [],
  error: false
};
